import debounce from 'lodash.debounce';
import { useRef, useState } from 'react';

export const useDebouncedState = <T = any>(defaultValue: T, wait: number = 500) => {
    const [value, setValue] = useState<T>(defaultValue);
    const debouncedSetValue = useRef(debounce(setValue, wait)).current;

    return [value, debouncedSetValue] satisfies [T, (value: T) => void];
};
